import { InjectionToken } from '@angular/core';

export interface AppConfig {
	envName: string;
	buildVer: string;
	domainAdminAPI: string;
	domainUserAPI: string;
	cdnUrl: string;
	insightKey: string;
	orthofixWebsite: string;
	orthofixMedicalEducation: string;
	customerCareEmail: string;
	recaptchaSiteKey: string;
	b2cTenantName: string;
	b2cTenantId: string;
	b2cSignInPolicyId: string;
	b2cResetPasswordPolicyId: string;
	b2cChangePasswordPolicyId: string;
	b2cClientId: string;
	b2cApplicationScope: string;
	appSSOutUriApi: string;
	idleTimeToEndSession: number;
	patplanSite: string;
	legalTermsSite: string;
	cookieName: string;
	cookiePolicyId: number;
	cookieSiteId: number;
	azureMapsSasTokenValidity: number;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');